// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80b3b0a2","455":"7984e474","977":"a6c595fc"}[chunkId] + ".chunk.js";
};